// extracted by mini-css-extract-plugin
export default {"section":"TicketMetricsSection_section__MkClI","metricsGrid":"TicketMetricsSection_metricsGrid__nvw1d"};